import http from "../http-common";
import { getToken, getTokenBearer } from "../utils/Utils";

const getAll = () => {
  return http.get("/customers-filters", {
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
};

const get = (id) => {
  return http.get(`/customers-filters/${id}`, {
    headers: {
      Authorization: getTokenBearer()
    }
  });
};

const create = (data) => {
  return http.post(`/customers-filters`, data, {
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
};

const remove = (id) => {
  return http.delete(`/customers-filters/${id}`, {
    headers: {
      Authorization: getTokenBearer()
    }
  });
};
const update = (id, data) => {
    console.log("Update Call - ID:", id, "Payload:", data); 
    return http.put(`/customers-filters/${id}`, data, {
      headers: {
        Authorization: getTokenBearer(),
      },
    });
  };

const CustomerFilterService = {
  getAll,
  get,
  create,
  remove,
  update
};

export default CustomerFilterService;
